export default (point1, point2) => {
    return Math.sqrt(
        point1
            .map((e, i) => [e, point2[i]])
            .reduce((accum, elem) => accum + Math.pow(elem[0] - elem[1], 2), 0)
    );
};
